import { owcTheme } from 'core/theme/theme.config';
import { TypographyBody1 } from 'commons/components';
import styled from 'styled-components';

export const SettingsTrainingBody = styled(TypographyBody1)`
    color: ${owcTheme['one-color-interaction-default-intensity-medium'] || '#544f4f'} !important;
`;
